<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Keyword" size="small" placeholder="请输入"></el-input>
            </div>

            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <!-- <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="showAddDialog()">新建保险公司</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <!-- <el-table-column
                type="index"
                width="100"
                label="序号"
                align="center"
                >
                </el-table-column> -->
                <el-table-column
                prop="id"
                label="案件ID"
                align="center"
                   width="120px"
                >
                </el-table-column>
                <el-table-column
                prop="cClmNo"
                label="赔案号"
                align="center"
                width="300px"
                >
                </el-table-column>
                <el-table-column
                prop="cDoubtId"
                label="任务ID"
                align="center"
                width="300px"
                >
                </el-table-column>
                <el-table-column
                prop="executeAction"
                label="调查结论"
                align="center"
                width="120px"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.executeAction==0">待接收</span>
                        <span v-else-if="scope.row.executeAction==10">已接受</span>
                        <span v-else-if="scope.row.executeAction==20">调查中</span>
                        <span v-else-if="scope.row.executeAction==30">待审核</span>
                        <span v-else-if="scope.row.executeAction==40">已完成</span>
                        <span v-else-if="scope.row.executeAction==50">已拒绝</span>
                        <span v-else-if="scope.row.executeAction==-1">已退回</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="cPlyNo"
                label="保单号"
                align="center"
                width="300px"
                >
                </el-table-column>
                <el-table-column
                prop="cInsuredNme"
                label="名字"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="tAccdntTm"
                label="出险时间"
                align="center"
                width="180px"
                >
                </el-table-column>
                
                <el-table-column
                prop="cAccdntPlace"
                label="出险地点"
                align="center"
                width="200px"
                >
                </el-table-column>
                
                
                <el-table-column
                fixed="right"
                label="操作"
                width="180px"
                align="center"
                >
                <template slot-scope="scope">
                   
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="task(scope.row)" >查看详情</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>



      
        
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionData , CodeToText } from "element-china-area-data";

export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            title:'',
            tableData:[],
            totalCount:0,
            conditionData:{
                Keyword:'',
                TaskSates:null,
                page:1,
                pageSize:10,
            },

        }
    },
    created(){
        
        console.log(localStorage.getItem('taskStatus'));
        let taskStatus = localStorage.getItem('taskStatus');
        if(taskStatus=='1-1'){
            this.conditionData.DcTaskAction = 0;
        }else if(taskStatus=='1-2'){
            this.conditionData.DcTaskAction = 10;
        }else if(taskStatus=='1-3'){
            this.conditionData.DcTaskAction = 20;
        }else if(taskStatus=='1-4'){
            this.conditionData.DcTaskAction = 30;
        }else if(taskStatus=='1-5'){
            this.conditionData.DcTaskAction = 40;
        }else if(taskStatus=='1-6'){
            this.conditionData.DcTaskAction = 50;
        }else if(taskStatus=='1-7'){
            // 已结案
            this.conditionData.DcTaskAction = 70;
        }else if(taskStatus=='1-8'){
            this.conditionData.DcTaskAction = 60;
        }
        this.loadingData();
    },
    mounted(){
    },
    methods:{
       
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            // let res  = await api.queryDcDoubtTask(this.conditionData);
            let res  = await api.queryPagerAnXinDcTask(this.conditionData);
            
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                Keyword:'',
                TaskSates:null,
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        handleCurrentChangeUser(page){
            this.userConditionData.page = page;
            this.queryUserByMechanismIds();
        },
        async auditTip(row){
            console.log(row);
            this.$confirm('是否接受此案件?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.examineTask(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async examineTask(row){
            let option = {
                id:row.id,
                taskSate:20
            };
            let res  = await api.examineTask(option);
            if(res.data.code == '200') {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        async task(row){
            console.log(row);
            this.$emit('addAnXinCase',{
                router:'anxinTaskDetail',
                name:'任务详情',
                index:'1-200',
                id:row.id
            });
            this.$router.push({
                name:'anxinTaskDetail',
                query:{
                    id:row.id
                }
            })
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 150px;
            }
            .value{
                width: 215px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
